import { BrowserRouter, Routes, Route } from "react-router-dom";
import Menu from "./Menu";
import FleetMetrics from "../../pages/fleet_metrics";
import { ChargerMetrics } from "../../pages/charger_metrics";
import OcppMessages from "../../pages/ocpp_messages";
import LogsDownload from "../../pages/logs_download";
import PrivateRoute from "./PrivateRoute";
import Login from "../../pages/Auth/Login";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <PrivateRoute>
              <Menu />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<FleetMetrics />} />
          <Route path="/charger" element={<ChargerMetrics />} />
          <Route path="/ocpp" element={<OcppMessages />} />
          <Route path="/logs" element={<LogsDownload />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
